export const CASE_LIST = [
  {
    title: 'OK',
    value: 'OK',
  },
  {
    title: 'PACU',
    value: 'PACU',
  },
  {
    title: 'NORA',
    value: 'NORA',
  },
  {
    title: 'ICU',
    value: 'ICU',
  },
  {
    title: 'Resus',
    value: 'RESUS',
  },
  {
    title: 'Konsul Prosedur',
    value: 'PROCEDURE_CONSULTATION',
  },
  {
    title: 'Poli Perioperative',
    value: 'POLI_PERIOPERATIVE',
  },
  {
    title: 'Manajemen Nyeri',
    value: 'PAIN_SERVICE',
  },
];
